import React from 'react';
import PropTypes from 'prop-types';

class PartDescription extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      available: this.props.available !== undefined && this.props.available,
      supplied: this.props.supplied !== undefined && this.props.supplied,
    };
  }

  get technicalInfo() {
    const infos = [];
    if (this.props.packing > 0) {
      infos.push(`Упаковка: ${this.props.packing} шт.`);
    }
    if (this.props.weight > 0) {
      infos.push(`Вес: ${this.props.weight.toLocaleString()} кг.`);
    }

    return infos.join(' ');
  }

  render() {
    let supplied;
    if (!this.state.supplied) {
      if (!this.state.available || (window._current_user && window._current_user.employee)) {
        supplied = <p className="has-text-danger">НЕ ПРОИЗВОДИТСЯ, НЕ ПОСТАВЛЯЕТСЯ</p>;
      }
    }

    let replacement;
    if (this.props.replacement) {
      replacement = (
        <p className="is-size-7">
          Замена номера на <a href={`/parts/${this.props.replacement.slug}`}>{this.props.replacement.article}</a>
        </p>
      );
    }

    return (
      <React.Fragment>
        {this.props.description}
        {this.props.comment && <p className="is-size-7 has-text-primary has-text-weight-bold">{this.props.comment}</p>}
        {supplied}
        {replacement}
        <p className="is-size-7">{this.technicalInfo}</p>
      </React.Fragment>
    );
  }
}

PartDescription.propTypes = {
  available: PropTypes.bool,
  comment: PropTypes.string,
  description: PropTypes.string,
  packing: PropTypes.number,
  replacement: PropTypes.object,
  supplied: PropTypes.bool.isRequired,
  weight: PropTypes.number,
};

export default PartDescription;
